import React, { useState, useEffect } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import ListItemText from "@mui/material/ListItemText";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { getTasks } from "features/tasks/api/Fetch";
import ListItemIcon from "@mui/material/ListItemIcon";
import { useTranslation } from "react-i18next";
import { IGetTasks, ITaskFields, IMyTasksFilter } from "../../types";

interface ITask {
  user: any;
}

const Tasks = (props: ITask) => {
  const [Tasks, setTasks] = useState<ITaskFields[]>();
  const { t } = useTranslation("shared");
  const { user } = props;

  async function UpdateTask() {
    var tasks: IGetTasks | undefined = await getTasks({
      AssignedChecked: true,
    } as IMyTasksFilter);
    if (tasks) {
      setTasks(tasks.items);
    }
  }

  useEffect(() => {
    UpdateTask();
  }, []);

  const RenderTask = (task: any) => {
    return (
      <ListItem button>
        <ListItemIcon>
          <AssignmentTurnedInIcon style={{ color: "#5d8c12" }} />
        </ListItemIcon>
        <ListItemText primary={task.task.title} />
        <ListItemSecondaryAction>
          <ListItemText
            primary={t(("statusList." + task.task.status) as any)}
          />
        </ListItemSecondaryAction>
      </ListItem>
    );
  };

  return (
    <div>
      <List component="nav" aria-labelledby="nested-list-subheader">
        {Array.isArray(Tasks) &&
          Tasks.map((task: any) => {
            return <RenderTask task={task} key={task.id} />;
          })}
      </List>
    </div>
  );
};

export default Tasks;
